import styled from 'styled-components';

export const Header = styled.header`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  & > svg {
    cursor: pointer;
    min-height: 14px;
    min-width: 14px;
    color: rgba(0, 0, 0, 0.54);
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 20px 100px;

  & > svg {
    min-width: 115px;
    min-height: 115px;
    color: #ec4d2c;
  }

  @media (max-width: 768px) {
    margin-top: 0;
    padding: 0;
  }
`;

export const TitleContent = styled.span`
  font-size: 18px;
  line-height: 28px;
  color: #777880;
  text-align: center;
`;

export const SubTitleContent = styled.span`
  font-size: 14px;
  line-height: 22px;
  color: ${({ theme }) => theme.colors.blue};
  text-align: center;

  & > button {
    border: none;
    background: transparent;
    color: inherit;
    font-size: inherit;
  }
`;

export const ContentButton = styled.div`
  width: 91%;

  & > button {
    width: 100%;
    background-color: #2dfffe;
    color: #0b29fb;

    &:disabled {
      background-color: #eeeeee;
      color: #7a7a7a;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;

  & > button {
    min-width: 35%;
  }

  @media (max-width: 768px) {
    margin-top: 16px;
  }
`;
